import { useState, useCallback } from 'react';

const useForm = (initialValues = {}, validationSchema = {}) => {
  const [values, setValues] = useState(initialValues);
  const [errors, setErrors] = useState({});

  const handleChange = useCallback((e) => {
    const { name, value } = e.target;
    setValues(prev => ({ ...prev, [name]: value }));
    setErrors(prev => ({ ...prev, [name]: undefined }));
  }, []);

  const validate = useCallback(() => {
    const newErrors = {};
    Object.keys(validationSchema).forEach(key => {
      const value = values[key];
      const rules = validationSchema[key];
      
      if (rules.required && !value) {
        newErrors[key] = `${key} is required`;
      } else if (rules.pattern && !rules.pattern.test(value)) {
        newErrors[key] = rules.message || `Invalid ${key}`;
      }
    });

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  }, [values, validationSchema]);

  const reset = useCallback(() => {
    setValues(initialValues);
    setErrors({});
  }, [initialValues]);

  return {
    values,
    errors,
    handleChange,
    validate,
    reset,
    setValues,
    setErrors
  };
};

export default useForm;
